import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { match } from 'path-to-regexp'
import { routeAccessConfig } from '@npm-client-frontends/client-frontends-shared-types'

export const AccessDenied = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const matchedConfig = routeAccessConfig.find(config => {
    const matcher = match(config.path, { decode: decodeURIComponent })
    return matcher(location.pathname)
  })

  const pageTitle = matchedConfig?.pageTitle || 'Access Denied'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'white',
        zIndex: 1000,
        gap: 2
      }}
    >
      <Typography variant="h4" component="h1">
        {pageTitle}
      </Typography>
      <Typography variant="body1">
        Your subscription restricts access to this content. Please contact your sales representative for more information.
      </Typography>
      <Typography variant="body1">
        You can find a description of this product and others at <a href="https://newprojectmedia.com/product">newprojectmedia.com/product</a>.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate('/')}
        sx={{ mt: 2 }}
      >
        Return to Dashboard
      </Button>
    </Box>
  )
}
